import {
  GET_CLIENT_KES,
  GET_CLIENT_MO,
  INSERT_CLIENT,
  GET_CLIENT_TYPE_KESM,
  GET_CLIENT_TYPE_MO,
  INSERT_CLIENT_TYPE,
  DELETE_CLIENT_MO,
  DELETE_CLIENT_KES,
  UPDATE_CLIENT_MO,
  UPDATE_CLIENT_KES,
  UPDATE_CLIENT_TYPE,
  DELETE_CLIENT_TYPE,
} from "../type";
import { InsertDataWithImage } from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import DeleteData from "../../Hooks/DeleteData";
import { InsUpdateData } from "../../Hooks/UpdataData";
export const CreateClientsAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertDataWithImage(`/api/Client`, data);
    dispatch({
      type: INSERT_CLIENT,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: INSERT_CLIENT,
      payload: "Error" + e,
    });
  }
};
export const GetAllClientsMowakelAction = (quary) => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/Client?${quary}`);
    dispatch({
      type: GET_CLIENT_MO,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GET_CLIENT_MO,
      payload: "Error" + e,
    });
  }
};
export const GetAllClientsKeshmAction = (quary) => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/Client?${quary}`);
    dispatch({
      type: GET_CLIENT_KES,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GET_CLIENT_KES,
      payload: "Error" + e,
    });
  }
};
export const CreateClientsTypeAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertDataWithImage(`/api/ClientType`, data);
    dispatch({
      type: INSERT_CLIENT_TYPE,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: INSERT_CLIENT_TYPE,
      payload: "Error" + e,
    });
  }
};
export const GetAllClientsTypeKesmAction = (quary) => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/ClientType?LawSuitType=${quary}`);
    dispatch({
      type: GET_CLIENT_TYPE_KESM,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GET_CLIENT_TYPE_KESM,
      payload: "Error" + e,
    });
  }
};
export const GetAllClientsTypeMowakAction = (quary) => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/ClientType?LawSuitType=${quary}`);
    dispatch({
      type: GET_CLIENT_TYPE_MO,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GET_CLIENT_TYPE_MO,
      payload: "Error" + e,
    });
  }
};
export const DeleteClientsMowakelAction = (id) => async (dispatch) => {
  try {
    const respons = await DeleteData(`/api/Client?id=${id}`);
    dispatch({
      type: DELETE_CLIENT_MO,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DELETE_CLIENT_MO,
      payload: "Error" + e,
    });
  }
};
export const UpdateClientsMowakelAction = (body) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(`/api/Client`, body);
    dispatch({
      type: UPDATE_CLIENT_MO,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATE_CLIENT_MO,
      payload: "Error" + e,
    });
  }
};
export const UpdateClientsKhesmlAction = (body) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(`/api/Client`, body);
    dispatch({
      type: UPDATE_CLIENT_KES,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATE_CLIENT_KES,
      payload: "Error" + e,
    });
  }
};
export const DeleteClientsKhesmlAction = (id) => async (dispatch) => {
  try {
    const respons = await DeleteData(`/api/Client?id=${id}`);
    dispatch({
      type: DELETE_CLIENT_KES,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DELETE_CLIENT_KES,
      payload: "Error" + e,
    });
  }
};
export const DeleteClientsTypelAction = (id) => async (dispatch) => {
  try {
    const respons = await DeleteData(`/api/ClientType?id=${id}`);
    dispatch({
      type: DELETE_CLIENT_TYPE,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DELETE_CLIENT_TYPE,
      payload: "Error" + e,
    });
  }
};
export const UpdateClientsTypelAction = (body) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(`/api/ClientType`,body);
    dispatch({
      type: UPDATE_CLIENT_TYPE,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATE_CLIENT_TYPE,
      payload: "Error" + e,
    });
  }
};
